export default "__VITE_ASSET__CBPqdypr__"